/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useContext } from 'react';
import { Icon, AntdModal } from '@brokerbay/design-components';
import styled from 'styled-components';
import { Button, Card, Typography } from 'antd';
import { SubscriptionsCardContext } from './SubscriptionsCardContext';

const { Title, Text } = Typography;
const { confirm } = AntdModal;

type BillingPlanCardProps = {
  billingPlan: {
    plan: string;
    price: number;
    descriptions: { text: string; includedFeature?: boolean }[];
  };
};

const BillingPlanCard: React.FC<BillingPlanCardProps> = ({
  billingPlan: { plan, price, descriptions },
}) => {
  const { downgradeBrokeragePlan } = useContext(SubscriptionsCardContext);

  const createDescription = ({
    text,
    includedFeature,
  }: {
    text: string;
    includedFeature?: boolean;
  }) => (
      <StyledDescription>
        <Icon
          type={includedFeature ? 'plus' : 'antdCheckOutlined'}
          color="primary"
        />
        <Text type="secondary">{` ${text}`}</Text>
      </StyledDescription>
    );

  const showConfirm = () => {
    confirm({
      title: 'Are you sure you want to downgrade?',
      icon: <Icon type="antdExclamationCircle" color="warning" />,
      content:
        'Your agents and admins will lose access to all upgraded features immediately. Any data related to upgraded features may be lost.',
      okText: 'Downgrade Plan',
      cancelText: 'Go Back',
      onOk: async () => {
        await downgradeBrokeragePlan();
      },
    });
  };

  return (
    <StyledCard
      bodyStyle={{
        height: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
      }}
    >
      <StyledHeader>
        <Title
          level={4}
          style={{ textTransform: 'capitalize' }}
          type="secondary"
        >
          {plan.toLowerCase()}
        </Title>
        <Text style={{ fontSize: '40px' }} strong>
          ${price}
        </Text>
        <Text type="secondary">per month</Text>
      </StyledHeader>
      <StyledContainer className="flex-container" style={{}}>
        <Text strong>Includes</Text>
        {descriptions.map(description => createDescription(description))}
      </StyledContainer>
      <StyledFooter>
        <Button
          type="primary"
          onClick={showConfirm}
          disabled={plan === 'BROKERAGE'}
          block
        >
          {plan === 'BROKERAGE' ? (
            <>
              <Icon type="antdCheckOutlined" color="textSecondary" /> Current
              Plan
            </>
          ) : (
            'Downgrade'
          )}
        </Button>
      </StyledFooter>
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  width: 95%;
`;

const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledContainer = styled.div`
  height: 70%;
  display: flex;
  flex-direction: column;
`;

const StyledFooter = styled.div`
  margin-top: 5px;
`;

const StyledDescription = styled.div`
  margin: 5px 0px 5px 5px;
`;

export default BillingPlanCard;
